export default __webpack_public_path__ + "static/media/bgsin.9939d370.jpg";